<template>
    <div>

        <div v-if="active" class="event-tab">
            <notes :event="event"></notes>
        </div>

    </div>
</template>

<script>
    import Notes from './EventNotes'

    export default {
        props: {
            active: Boolean,
            event: Object
        },

        components: {
            Notes
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

</style>



// WEBPACK FOOTER //
// EventNotesTab.vue?744d0b84